import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, LoadingController, AlertController } from 'ionic-angular';
import { ModalEventoPage } from '../modal-evento/modal-evento';
import { ModalInscricaoPage } from '../modal-inscricao/modal-inscricao';
import { LoginPage } from "../login/login";
import { HomePage } from '../home/home';



import { Http } from '@angular/http';

import config from '../../config/config';
/**
 * Generated class for the EventoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-evento',
  templateUrl: 'evento.html',
})
export class EventoPage {
  usuario: any;
  dados = null;
  permissao = null;
  eventos = [];
  bemVindo = null;

  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController
  ) {
  }

  ionViewDidLoad() {
    this.usuario = this.navParams.get('usuario');
    this.bemVindo = this.usuario.bemVindo;
    this.dados = this.navParams.get('dados');
    this.permissao = this.navParams.get('permissao');
    this.geteventos();
  }
  geteventos() {
    this.eventos = [];
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "listar/eventos", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        loading.dismiss();
        for (let t = 0; t < res.length; t++) {
          console.log(res)
          let baixar = res[t].limite;
          res[t].inscritos.forEach(inscrito => {
            if (inscrito.usuario_id === this.usuario.id) {
              baixar = true;
            }
          });
          res[t].baixar = baixar;
          var _str = res[t].data;
          let _new = _str.split('-').reverse().join('-');
          res[t].data = _new;

          this.eventos.push(res[t]);
        }
          console.log(this.eventos);


      }).catch(error => {

      });
  }
  InscreverseEvento(ev) {




    if (this.usuario.dados.emDia != 'S' || this.usuario.dados == null) {
      let msg = "Para Realizar a sua inscrição é necessário realizar uma atualização no seu perfil."


      this.modalinformativo(msg)
      return true;

    } else {
      let Modal = this.modalCtrl.create(ModalInscricaoPage, { usuario: this.usuario, ev: ev });
      Modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      });
      Modal.present();
    }

  }
  modalinformativo(msg) {
    let alert = this.alertCtrl.create({
      title: "Evento",
      message: msg,
      buttons: [
        {
          text: "OK",
          handler: () => {
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  EncerrarEvento(ev) {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .post(config.urlAPI + "encerrar/eventos", ev, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        loading.dismiss();
        this.geteventos();
      }).catch(error => {

      });
  }
  alterarEvento(ev) {

  }
  cadastroEvento() {
    let Modal = this.modalCtrl.create(ModalEventoPage, { usuario: this.usuario });
    Modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    Modal.present();
  }
  goToLogout() {
    sessionStorage.clear();
    this.navCtrl.setRoot(LoginPage);
  }
  baixarComprovante(idEvento) {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    console.log('baixar');
    const self = this;
    var iframe = document.querySelector("#iframe-carteirinha");
    iframe.setAttribute('src', 'https://backend.homologacao.sintufrj.org.br/public/api/gerar/validacao/' + this.usuario.id + '/' + idEvento);
    document.getElementById("iframe-carteirinha").click();
    setTimeout(function () {
      loading.dismiss();
      self.navCtrl.setRoot(HomePage);
    }, 2000);

  }

}



// WEBPACK FOOTER //
// ./src/pages/evento/evento.ts